import {Tile} from "./Tile";
import {Pawn} from "./Pawn";

export class Checkerboard {
    tiles;
    pawns;

    constructor(matrix) {
        this.tiles = [];
        this.pawns = [];

        const maxY = matrix.length - 1

        matrix.forEach((row, y) => {

            row.forEach((color, x) => {
                if (matrix[x][y] === 1 || matrix[x][y] === 2 || matrix[x][y] === 4) {
                    this.tiles.push(new Tile(x, y, color));

                    if (y === 0) {
                        this.pawns.push(new Pawn(x, y, color, 1));
                    }

                    if (y === maxY) {
                        this.pawns.push(new Pawn(x, y, color, 2));
                    }

                } else {
                    console.error("Format du damier invalide");
                }

            });
        });
    }

    getTile(x, y) {
        return this.tiles.find(checkerboardTile => checkerboardTile.x === x && checkerboardTile.y === y) || null;
    }

    getPawn(x, y, layer = 1, player = 0) {
        if (player === 0) {
            return this.pawns.find(pawn => pawn.x === x && pawn.y === y && pawn.layer === layer) || null;
        } else {
            return this.pawns.find(pawn => pawn.x === x && pawn.y === y && pawn.layer === layer && pawn.player === player) || null;
        }
    }

    getAllPawnsOnTile(x, y) {
        return this.pawns.filter(pawn => pawn.x === x && pawn.y === y);
    }

    removePawn(x, y, layer = 1) {
        const index = this.pawns.findIndex(pawn => pawn.x === x && pawn.y === y && pawn.layer === layer);
        if (index !== -1) {
            this.pawns.splice(index, 1);
        }
    }
}